import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const FishSpeciesList = Loadable(lazy(() => import("./FishSpeciesList")));
const FishSpeciesForm = Loadable(lazy(() => import("./FishSpeciesForm")));

const fishSpeciesRoutes = [
  {
    path: "/FishSpecies/FishSpeciesList",
    element: <FishSpeciesList />,
    permission: PERMISSIONS.FishSpecies.Menu,
  },
  {
    path: "/FishSpecies/FishSpeciesForm",
    element: <FishSpeciesForm />,
  },
  {
    path: "/FishSpecies/FishSpeciesForm/:fishSpeciesId",
    element: <FishSpeciesForm />,
  },
];

export default fishSpeciesRoutes;
